import { useEffect } from 'react'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useParams, useBlocker, useNavigate } from 'react-router-dom'
import { useUrlStore } from '@repo/store/useUrlStore'

export const useNavBlockerForClientMatterNo = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { urlDecodeClientMatterNo, urlEncodeClientMatterNo, routeId } = useUrlStore()
  const { currentClientMatterNo } = useMattersStore()

  const { clientMatterNo, clientNo } = params?.clientMatterNo
    ? urlDecodeClientMatterNo({ clientMatterNoParam: params.clientMatterNo }) || {}
    : {}

  // block the navigation if the clientMatterNo is different to the current one. There's a useEffect below that will set the current matter if the blocker is blocked.
  const blocker = useBlocker(params?.clientMatterNo && clientMatterNo !== currentClientMatterNo)

  useEffect(() => {
    if (blocker.state === 'blocked') {
      console.warn('NavBlockerForClientMatterNo: blocker is blocked, setting current matter to', clientMatterNo)
      blocker.reset()

      // navigate to the change matter page, which will update the current matter in the Osprey 1 context and then redirect to the original route


      const encodedClientMatterNo = urlEncodeClientMatterNo({ clientMatterNo })
      const newClientMatterNoParam = `clientMatterNo=${encodedClientMatterNo}`
      const route = routeId.replace('/:clientMatterNo', '')
      const redirectParam = `redirectTo=${route}`
      const appendClientMatterNoParam = params?.clientMatterNo ? `appendClientMatterNo=true` : ''

      const queryParams = [newClientMatterNoParam, appendClientMatterNoParam, redirectParam].filter(Boolean).join('&')
      const newRoute = `/change-matter?${queryParams}`

      navigate(newRoute)
    }
  }, [blocker, clientMatterNo, clientNo, currentClientMatterNo, navigate, params, routeId, urlEncodeClientMatterNo])
}
